import { defineComponent, ref, watch } from "vue";
import Select from "../Select/index.mjs";
import OPtion from "../Option/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DatepickerH5",
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props, { emit }) {
    const props = __props;
    const currentValue = ref();
    watch(
      () => props.value,
      (val) => {
        if (!val) return;
        currentValue.value = new Date(val).getTime();
      },
      { immediate: true }
    );
    watch(currentValue, (val) => emit("input", new Date(val)), { immediate: true });
    function generateYearDates(year) {
      const startDate = new Date(year, 0, 1);
      const endDate = new Date(year, 11, 31);
      const dates = [];
      const currentDate = startDate;
      while (currentDate <= endDate) {
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
        dates.push(
          `${year}/${month < 10 ? `0${month}` : month}/${day < 10 ? `0${day}` : day}`
        );
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return dates;
    }
    const yearDates = generateYearDates((/* @__PURE__ */ new Date()).getFullYear()).map((item) => ({
      label: item,
      value: new Date(item).getTime()
    }));
    return { __sfc: true, props, emit, currentValue, generateYearDates, yearDates, TuiSelect: Select, TuiOption: OPtion };
  }
});
export {
  _sfc_main as default
};
